export type Config = {
  baseUrl: string
}

export const gatewayApiConfig: Config = {
  baseUrl: import.meta.env.VITE_API_GATEWAY_URL as string,
}

export const apiConfig: Config = gatewayApiConfig
